import { render, staticRenderFns } from "./ListChat.vue?vue&type=template&id=515a5091&scoped=true&lang=html&"
import script from "./ListChat.vue?vue&type=script&lang=js&"
export * from "./ListChat.vue?vue&type=script&lang=js&"
import style0 from "./ListChat.vue?vue&type=style&index=0&id=515a5091&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515a5091",
  null
  
)

export default component.exports